import React from 'react';
import useIntl from '../useIntl';
/**
 * React component to format a number
 */
export default function FormatNumber(props) {
    var formatNumber = useIntl().formatNumber;
    return React.createElement(React.Fragment, null, formatNumber(props));
}
